import Tooltips from "../ui/tooltip";
import NavMenuItem from "../ui/nav-menu-item";
import { Search } from "lucide-react";
import ActionIcon from "../ui/action-icon";
import UserContext from "../../contexts/user-context";
import BusinessContext from "../../contexts/business-context";
import { useContext, useState, useEffect } from "react";
import { useTranslations } from "next-intl";
import { isPegInstalled, isStaging } from "../../lib/auth";
import GeneralSearchModal from "./general-search-modal";
import Staging from "./staging";
import Production from "./production";
import DynamicIcon from "../ui/dynamic-icon";
import { getCommandKey } from "../../lib/utils";

const TopNav = () => {
    const userCtx = useContext(UserContext);
    const businessCtx = useContext(BusinessContext);
    const business = businessCtx.activeBusiness;
    const user = userCtx.user;
    const t = useTranslations('nav');
    const [isSearchModalOpen, setSearchModalOpen] = useState(false);
    const toggleSearchModal = () => { setSearchModalOpen(!isSearchModalOpen) }

    useEffect(() => {
        const handleKeyDown = (e) => {
            if ((e.ctrlKey || e.metaKey) && e.key === 'k') {
                e.preventDefault();
                toggleSearchModal();
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [isSearchModalOpen]);

    if (user.is_pseudonymous || business.is_pseudonymous) {
        return null;
    }

    return (
        <>

            <div className="grid gap-[4px]  lg:px-[17.5px]">
                <Tooltips position="right" content="Open search" command={`${getCommandKey("⌘", "Ctrl")} + k`}>
                    <div
                        onClick={() => { toggleSearchModal() }}
                        className={`grid grid-flow-col justify-start items-center group hover:custom-bg-grey-50 cursor-pointer w-full text-[12px] h-[35px] px-[27px] gap-[12px] rounded-[8px] custom-text-grey-800 `}>
                        <DynamicIcon name="search" size={16} color="currentColor" />
                        <span className={`custom-text-grey-500  poppins-medium text-[12px] tracking-[0.5px]`}>{t('search')}</span>
                    </div>
                </Tooltips>

                <NavMenuItem history={() => { setHistory(true) }} icon="sparkles" href="/chats">
                    {t('workpegAI')}
                </NavMenuItem>

                <NavMenuItem icon="house" href="/home">
                    {t('home')}
                </NavMenuItem>
            </div>
            <GeneralSearchModal toggleModal={toggleSearchModal} isOpen={isSearchModalOpen} />
        </>
    );
};

export default TopNav;